import { ThemeEvents } from '@theme/events';

class SensateaGiftTrack extends HTMLElement {
  connectedCallback() {
    this.cards = this.querySelectorAll('[data-gift-card]');
    this.statusEl = this.querySelector('[data-gift-status]');
    this.whiskAt = parseInt(this.dataset.whiskUnlock || '3', 10);
    this.shipAt = parseInt(this.dataset.shipUnlock || '2', 10);
    this.whiskVariantId = String(this.dataset.whiskVariantId || '47484443099479');
    this.onUpdate = () => this.sync();
    document.addEventListener(ThemeEvents.quantityBreaksUpdated, this.onUpdate);
    this.observer = new MutationObserver(() => this.sync());
    this.#observeBreaks();
    this.#patchQuantityBreaks();
    this.#patchProductForm();
    if (window.customElements?.whenDefined) {
      customElements.whenDefined('quantity-breaks').then(() => this.#patchQuantityBreaks());
      customElements.whenDefined('product-form').then(() => this.#patchProductForm());
    }
    requestAnimationFrame(() => {
      this.#observeBreaks();
      this.#patchQuantityBreaks();
      this.sync();
    });
    setTimeout(() => {
      this.#observeBreaks();
      this.#patchQuantityBreaks();
      this.sync();
    }, 500);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.quantityBreaksUpdated, this.onUpdate);
    this.observer?.disconnect();
  }

  #observeBreaks() {
    document.querySelectorAll('[data-ref="quantity-break-item"]').forEach((el) => {
      this.observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  getSelectedQty() {
    const selected = document.querySelector('.quantity-break--selected');
    if (selected?.dataset?.quantity) return parseInt(selected.dataset.quantity, 10);
    return parseInt(this.dataset.defaultQty || '2', 10);
  }

  shouldIncludeWhisk(qty = this.getSelectedQty()) {
    return qty >= this.whiskAt && Boolean(this.whiskVariantId);
  }

  /** Ensure ATC cart payload includes free chasen at unlock qty */
  #ensureWhiskInItems(items) {
    const list = Array.isArray(items) ? [...items] : [];
    if (!this.shouldIncludeWhisk()) return list;
    const id = this.whiskVariantId;
    const exists = list.some((item) => String(item.id) === id);
    if (!exists) list.push({ id, quantity: 1 });
    return list;
  }

  #patchQuantityBreaks() {
    const Ctor = customElements.get('quantity-breaks');
    if (!Ctor || Ctor.prototype.__sensateaWhiskPatched) return;
    const original = Ctor.prototype.getSelectedItems;
    const track = this;
    Ctor.prototype.getSelectedItems = function patchedGetSelectedItems(...args) {
      const items = original.apply(this, args);
      return track.#ensureWhiskInItems(items);
    };
    Ctor.prototype.__sensateaWhiskPatched = true;
  }

  #patchProductForm() {
    // Also wrap merge path if form exposes getSelectedItems later
    const forms = document.querySelectorAll('[data-ref="product-form"]');
    forms.forEach((form) => {
      if (form.__sensateaWhiskPatched) return;
      form.__sensateaWhiskPatched = true;
      // Capture-phase click before ATC handler runs
      form.addEventListener(
        'click',
        (event) => {
          const btn = event.target?.closest?.('[data-ref="add-to-cart"], button[type="submit"], [name="add"]');
          if (!btn) return;
          this.sync();
          this.#patchQuantityBreaks();
        },
        true
      );
    });
  }

  #setStatus(qty) {
    if (!this.statusEl) return;
    let msg = '';
    const d = this.dataset;
    const fmt = (s, n) => s.replace('[count]', n);
    if (qty >= this.whiskAt) {
      msg = d.msgBest || 'Livraison + chasen offerts — votre meilleure affaire.';
    } else if (qty >= this.shipAt) {
      const left = this.whiskAt - qty;
      msg =
        left === 1
          ? d.msgShipOne || 'Livraison offerte débloquée. Ajoutez 1 Matcha Sensatea pour le chasen offert.'
          : d.msgShipMany ? fmt(d.msgShipMany, left) : `Livraison offerte débloquée. Encore ${left} Matchas Sensatea pour le chasen.`;
    } else {
      const left = this.shipAt - qty;
      msg =
        left === 1
          ? d.msgLockOne || 'Ajoutez 1 Matcha Sensatea pour débloquer la livraison offerte.'
          : d.msgLockMany ? fmt(d.msgLockMany, this.shipAt) : `Choisissez ${this.shipAt} Matchas Sensatea pour la livraison offerte.`;
    }
    this.statusEl.textContent = msg;
  }

  sync() {
    const qty = this.getSelectedQty();
    this.cards.forEach((card) => {
      const need = parseInt(card.dataset.unlockAt, 10);
      const unlocked = qty >= need;
      card.classList.toggle('is-unlocked', unlocked);
      card.classList.toggle('is-locked', !unlocked);
    });
    this.#setStatus(qty);
  }
}

if (!customElements.get('sensatea-gift-track')) {
  customElements.define('sensatea-gift-track', SensateaGiftTrack);
}
